import * as nodePath from 'node:path';
import type { AppFiles } from '~/lib/projects';

export type ImportFileEntry = string | { binary: string };

export function convertImportFilesToAppFiles(files: Record<string, ImportFileEntry>): AppFiles {
  const lastModified = Date.now();

  const result: AppFiles = {};

  for (const [path, entry] of Object.entries(files)) {
    let isBinary = false;
    let contents = '';

    if (typeof entry === 'string') {
      contents = entry;
    } else {
      if ('binary' in entry) {
        isBinary = true;
        contents = entry.binary;
      }
    }

    result[path] = {
      type: 'file',
      name: nodePath.basename(path),
      fullPath: path,
      contents,
      lastModified,
      isBinary,
    };
  }

  return result;
}
